import { Box, Flex } from "@chakra-ui/react";
import SettingsDescription from "../elements/SettingsDescription";
import SettingsHeader from "../elements/SettingsHeader";
import { useEffect, useState } from "react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { Fields } from "./fields/fields";
import { FieldViewModel } from "./fields/field.view-model";
import { LoanTypes } from "./loan-types/loan-types";

export function FieldSettings() {
  const { user } = useTenant();
  const [fields, setFields] = useState<FieldViewModel[]>([]);

  function handleFieldsReordered(fields: FieldViewModel[]) {
    setFields(fields);
  }

  function handleHideFromBorrowers(fields: FieldViewModel[]) {
    setFields(fields);
  }

  useEffect(() => {
    setFields(
      user.company.fields.sort((a: FieldViewModel, b: FieldViewModel) => a.order - b.order)
    );
  }, [user.company.fields]);

  function handleOnUpdate(field: FieldViewModel) {
    setFields(fields.map(f => (f.id === field.id ? field : f)));
  }

  function handleOnDelete(field: FieldViewModel) {
    setFields(fields.filter(f => f.id !== field.id));
  }

  function handleOnAdd(field: FieldViewModel) {
    setFields([...fields, field]);
  }

  return (
    <Flex direction="column" gap={8}>
      <Box>
        <SettingsHeader title="Loan Fields" />
        <SettingsDescription text="Customize the data you collect about loans. All loan fileds added here will be the default field in all loan types." />
        <Fields
          fields={fields}
          loan_type={null}
          onFieldsReordered={handleFieldsReordered}
          onHideFromBorrowers={handleHideFromBorrowers}
          onFieldAdded={handleOnAdd}
          onFieldUpdated={handleOnUpdate}
          onFieldDeleted={handleOnDelete}
        />
      </Box>
      <LoanTypes />
    </Flex>
  );
}
